import React from 'react';

import CustomTitleLabelWithEditorBar from 'components/base/CustomTitleLabelWithEditorBar';
import ProfileTextField from 'components/customer/additionalData/ProfileTextField';

const ProfileOtherFieldSection = ({
  otherFields,
  newUserCustomData,
  setNewUserCustomData,
}) => {
  const setValue = (v, fieldName) => {
    const value = {
      ...newUserCustomData,
    };
    value[fieldName] = v;
    setNewUserCustomData(value);
  };
  if (otherFields?.length > 0) {
    return (
      <div className="customer-section-area">
        <div className="create-section-title">Other fields</div>
        {otherFields?.map((fieldName) => {
          const defaultValue = newUserCustomData?.[fieldName];
          return (
            <ProfileTextField
              key={fieldName}
              fieldName={fieldName}
              displayTitle={fieldName}
              defaultValue={defaultValue}
              setValue={(v) => setValue(v, fieldName)}
            />
          );
        })}
      </div>
    );
  }
  return null;
};

export default ProfileOtherFieldSection;
